<template>
<div class="bulkedit">
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
        <h1 class="h3 mb-0 text-gray-800">Full Job Table</h1>
        <!--<a href="#" class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm"><i class="fas fa-download fa-sm text-white-50"></i> Generate Report</a>-->
    </div>
    <div class="card shadow mb-4">       
        <div id="dataTable_wrapper" class="dataTables_wrapper dt-bootstrap4 card-body">

            <div class="dataTables_length table-filters" id="dataTable_length">

                <div>
                                <label  label v-if="users" v-bind:class="{selectedFilter: assignedFilter !== 'all'}">Assigned:
                                    <select v-model="assignedFilter" @change="assignedChange($event)" name="dataTable_length" required aria-controls="dataTable" class="custom-select form-control mb-0">
                                        <option value="all">Any Users</option>
                                        <option :value="null">Unassigned</option>
                                        <option :value="user.name" v-for="(user, i) in users" v-bind:key="i">{{user.name}}</option>
                                    </select>
                                </label>
                                <label class="ml-3" v-bind:class="{selectedFilter: statusFilter !== 'all'}">Status:
                                    <select @change="statusChange($event)" v-model="statusFilter" name="dataTable_length" required aria-controls="dataTable" class="custom-select form-control mb-0">
                                        <option value="all">Any Status</option>
                                        <option>Created</option>
                                        <option>Follow Up</option>
                                        <option>Container/eCubes Deployed</option>
                                        <option>Pickup Booked</option>
                                        <option>Inwards Recorded</option>
                                        <option>Teardown/Processing</option>
                                        <option>Shred/NZISM</option>
                                        <option>Data Destruction Complete</option><option>Dropping Off</option>
                                        <option>Finalise</option>
                                        <option>Invoice</option>
                                        <option>Completed</option>
                                    </select>
                                </label>
                                <label class="ml-3" for="picker" v-if="users" v-bind:class="{selectedFilter: dateRange.startDate !== null && dateRange.endDate !== null}">Date Range:
                                    <date-range-picker ref="picker" opens="center"  v-model="dateRange">
                                        <template v-slot:input="picker" style="min-width: 350px;">
                                            {{ picker.startDate | date  }} - {{ picker.endDate | date  }}
                                        </template>
                                    </date-range-picker>
                                </label>

                                <div style="display: inline-block;"  class="ml-4" id="dataTable_paginate">
                                     <button v-if="user && user.data && user.data.role > 8" @click="downloadCSV(jobs)" class="btn btn-info"><i class="fas fa-fw fa-file-excel"></i> Download CSV</button>
                                </div>
                </div>
                <div id="dataTable_filter" style="max-width:280px;margin-bottom: 0.5rem;" class="dataTables_filter input-group"><input type="text" v-model="searchText" placeholder="Search by Job# or Email" aria-label="Search" v-on:keyup.enter="search()" class="form-control ">
                    <div class="input-group-append"><button @click="search()" type="button" class="btn btn-primary"><i class="fas fa-search fa-sm"></i></button></div>
                </div>

            </div>
            <div class="table-responsive-xl">
                <div>
                    <table class="table focused selectable">
                        <thead>
                            <tr>
                                <th class="col-date">Sent</th>
                                <th class="col-job">Job#</th>
                                <th>Business</th>
                                <th>Name</th>
                                <th class="col-address">Address</th>
                                <th class="col-job">Status</th>
                                <th class="col-job">Assd</th>
                                <th class="col-job">Flags</th>
                                <th class="col-arrow"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <router-link v-bind:class="{disable: job.status==='Cancelled'}" class="rw" tag="tr" :to="{ name: 'job-view', params: { id: $options.filters.jobid(job.jobid), key: job['.key'] } }" v-for="(job, index) in jobs" v-bind:key="index">
                                <td class="col-date" :time="job.submitted">{{job.submitted | fullDate}}</td>
                                <td class="col-job">{{job.jobid | jobid}}</td>
                                <td>{{job.company}}</td>
                                <td :title="job.name + ' (' + job.email + ')'">{{job.name}} ({{job.email}})</td>
                                <td class="col-address">{{job.address}}</td>
                                <td class="col-job"><span style="margin:auto 0;" :style="{ background: $options.filters.statusHex(job.status)}" class="badge badge-lg">{{job.status}}</span></td>
                                <td class="col-job py-1">
                                    <div v-html="$options.filters.getCaps(job.assignedTo, job.assignedUID, users)"></div>
                                </td>
                                <td class="col-job"><i title="Admin Attachment(s)" v-if="job.adminAttachments && job.adminAttachments.length > 0" class="text-info fas fa-fw fa-file"></i><i title="Inward Goods Received" v-if="job.inwards && job.inwards.length > 0" class="text-secondary fas fa-fw fa-truck"></i><i :title="job.datadestruction + ' Data Destruction'" v-if="job.datadestruction !== 'No'" class="text-danger fas fa-fw fa-database"></i></td>
                                <td class="col-arrow"><i class="fas fa-fw fa-chevron-right"></i></td>
                            </router-link>
                        </tbody>
                    </table>
                </div>
            </div>


                <button class="btn btn-danger btn-center" @click="update()">Update {{jobs.length}} DB</button>

        </div>
    </div>
</div>
</template>

<script>
//import HelloWorld from './components/HelloWorld.vue'
// Get a RTDB instance

import {
    db
} from "../main";

import {
    mapGetters
} from "vuex";
import DateRangePicker from 'vue2-daterange-picker'
//you need to import the CSS manually (in case you want to override it)

import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
const jobsRef = db.ref("jobs2020");

export default {
    name: "Dashboard",
    components: {
        // HelloWorld,
        DateRangePicker
    },
    data() {
        return {
            jobsRaw: [],
            limit: 10000,
            //startAt: 0,
            maxLimit: 100000,
            endAt: 100000,
            pageNo: 1,
            searchText: '',
            dateRange: {
                startDate: "",
                endDate: ""
            },
            maxDate: new Date(),
            opened: [],
            users: [],
            assignedFilter: "all",
            statusFilter: "all",
        };
    },
    filters: {
        date(date) {
            if (date) {
                return new Intl.DateTimeFormat("en-NZ").format(date);
            } else {
                return "__/__/__"
            }
        }
    },
    computed: {
        ...mapGetters({
            user: "user"
        }),
        jobs: function () {
            return [...this.jobsRaw].reverse();
        },
        combinedWatch() {
            return this.statusFilter + this.limit + this.assignedFilter + this.dateRange.startDate + this.dateRange.endDate
        },
    },
    firebase: {
        users: db.ref('users').orderByChild('role').limitToLast(50).startAt(8),
    },
    methods: {
        update() {
            if (confirm("DANGER: Are You Sure You want to Update the DB?")) {
                console.log('yes');

                // This will only send the values and ignore the keys
                this.bulkUpdate(jobsRef, this.jobsRaw);

            } else {
                console.log('cancel');
            }
        },
        statusChange() {
            this.assignedFilter = "all";
            this.dateRange = {
                startDate: null,
                endDate: null
            }
        },
        assignedChange() {
            this.statusFilter = "all";
            this.dateRange = {
                startDate: null,
                endDate: null
            }
        },
        downloadCSV(items) {
            var t = this;
            let csvContent = "data:text/csv;charset=utf-8,";

            csvContent += '"Date","ID","Status","Business","Items", "Customer Name","Phone","Email","Address","Accounts"' + '\r\n';
            items.forEach(function (rw) {
                let row = '"' + t.$moment(rw['submitted']).format("DD/MM/YY h:mma") + '",';
                row += '"' + rw['jobid'] + '",';
                row += '"' + rw['status'] + '",';
                row += '"' + rw['company'] + '",';

                if(rw['itemoption'] === 'upload'){
                     row += '"' + 'https:/itrecycla.co.nz/wp-content/themes/blankslate/uploads/' + rw['attachment'] + '",';
                }else{
                   var items = "";
                    for (const prop in rw['items']) {
                        console.log('prop', prop)
                        var propObj = rw['items'][prop];
                        items += propObj.description + ' - ' + propObj.quantity + ', ';
                    }

                    row += '"' + items.slice(0, -2) + '",';
                    console.log('items', items);
                }
                row += '"' + rw['name'] + '",';
                row += '"' + rw['phone'] + '",';
                row += '"' + rw['email'] + '",';
                row += '"' + rw['address'] + '",';
                row += '"' + rw['accounts'] + '",';
                csvContent += row + '\r\n';
            });

            var encodedUri = encodeURI(csvContent);
            var link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            
            //var branch = this.$options.filters.branchFilter(t.filters.branch);

            link.setAttribute("download", "jobslist-" + this.$moment(Date.now()).format("DDMMMYYYY") + ".csv");
            document.body.appendChild(link); // Required for FF

            link.click();
        },
        bulkUpdate(ref, collection) {
            console.log('bulk', collection.length);
            // object to hold the bulk update
            var t = this;
            // using Object.keys will allow us to iterate over an array or object
            collection.forEach(function (item) {
                //item.status = "Completed";
                //item.statusChangeDate = "2020-10-30T08:00:00.000Z";  //REWRITE SOME VALUES
                //using the pushId, assign the value to the bulk update object
                if(item.status==='Completed'){
                    console.log(item, t);
                    t.singleUpdate(item); //ADD ITEM TO JOB ARCHIVE
                    db.ref('jobs2020/' + item['.key']).remove();
                }
                //db.ref('jobs2020/' + item['.key']).remove(); //DELETE ITEM FROM JOBS LIST
            });

            // send the bulk update to Firebase

        },
        singleUpdate(item){
            console.log(item);
                    db.ref("jobsArchive/" + item['.key']).set(item,
                        function (error) {
                            console.log('error', error)
                            if (error) {
                                // The write failed...
                                //t.error = error;
                            } else {
                                //t.success = "New User Created Successfully ";

                                // Data saved successfully!
                            }
                        }
                    );
        },
        loadMore() {
            this.limit += 100;
        },
        nextEndAt() {
            this.pageNo += 1;
            this.startAt = this.jobs[0].jobid;
            this.endAt = this.jobs[this.jobs.length - 1].jobid;
            console.log(this.endAt);
        },
        search() {
            const t = this;
            var srch = t.searchText.trim();
            if (srch !== '') {
                console.log(srch);
                if (srch.indexOf("@") != -1) {
                    this.$router.push({
                        name: 'job-search',
                        query: {
                            email: srch
                        }
                    })
                } else {
                    var intSearch = parseInt(srch);
                    console.log(intSearch);
                    console.log(isNaN(intSearch));
                    if (typeof intSearch === "number") {
                        this.$router.push({
                            name: 'job-view',
                            params: {
                                id: intSearch
                            }
                        })
                    }
                }
            }

        },
        prevEndAt() {
            this.pageNo -= 1;
            if (this.pageNo != 1) {
                this.endAt = this.startAt;
            } else {
                this.endAt = this.maxLimit;
            }
            //this.endAt = 100000;
            console.log(this.startAt);
        },
        changePage() {},
    },
    watch: {
        combinedWatch: {
            // call it upon creation too
            immediate: true,
            handler() {
                if (this.assignedFilter !== "all") {
                    this.statusFilter = "all";
                    this.dateRange.startDate = "";
                    this.dateRange.startEnd = "";
                    this.$rtdbBind(
                        "jobsRaw",
                        // jobsRaw.orderByChild("jobid").limitToLast(this.limit).endAt(this.endAt)
                        jobsRef.orderByChild("assignedTo").equalTo(this.assignedFilter).limitToLast(this.limit)
                    );
                } else if (this.statusFilter !== "all") {
                    this.assignedFilter = "all";
                    this.dateRange.startDate = "";
                    this.dateRange.startEnd = "";
                    this.$rtdbBind(
                        "jobsRaw",
                        // jobsRaw.orderByChild("jobid").limitToLast(this.limit).endAt(this.endAt)
                        jobsRef.orderByChild("status").equalTo(this.statusFilter).limitToLast(this.limit)
                    );
                } else if (this.dateRange.startDate !== "" && this.dateRange.endDate !== "") {
                    this.assignedFilter = "all";
                    this.statusFilter = "all";
                    console.log('dateStart', this.dateRange.startDate.toISOString());
                    this.$rtdbBind(
                        "jobsRaw",
                        // jobsRaw.orderByChild("jobid").limitToLast(this.limit).endAt(this.endAt)
                        jobsRef.orderByChild("submitted").startAt(this.dateRange.startDate.toISOString()).endAt(this.dateRange.endDate.toISOString()).limitToLast(this.limit)
                    );
                } else {
                    this.$rtdbBind(
                        "jobsRaw",
                        // jobsRaw.orderByChild("jobid").limitToLast(this.limit).endAt(this.endAt)
                        jobsRef.orderByChild("jobid").limitToLast(this.limit)
                    );
                }
            },
        },
    },
    /*firebase: {
      jobsRaw: db.ref('jobsArchive').orderByChild('jobid').limitToLast(20),
    },*/
};
</script>

<style>
</style>
